import gql from 'graphql-tag';

export const syncSapOutagesForFacility = gql`
  mutation syncSapOutagesForFacility($floc: String) {
    syncSapOutagesForFacility(floc: $floc) {
      value
    }
  }
`;
